import nweaTheme from './nweaTheme';

export { nweaTheme };

export default nweaTheme;
